<template>
  <div :class="classes" class="trade-last-orders">
    <trade-top-heading-block
      class="
        trade-last-orders__head
        txt--color-04 txt--14px txt--height-18px txt--weight-500 pb-10 pt-10 pl-12 pr-12 bor--bottom bor--transp-02
      "
    >
      <span class="trade-last-orders__title" v-text="$t('trade.orderBook')" />
      <trade-last-orders-tabs />
      <!-- <exc-tabs
        :selected-button="typeTab"
        :buttons="tabs"
        no-active-item-styles
        tab-key="value"
        size="xs"
        class="trade-last-orders__tabs"
        @change-tab="onClickTab"
      >
        <template #all="{ isActive }">
          <span>
            <img
              :class="{'active bg--transp-01': isActive}"
              class="bor--radius-02"
              src="/img/trade/all-tab.svg"
            >
          </span>
        </template>
        <template #buy="{ isActive }">
          <span>
            <img
              :class="{'active bg--transp-01': isActive}"
              class="bor--radius-02"
              src="/img/trade/buy-tab.svg"
            >
          </span>
        </template>
        <template #sell="{ isActive }">
          <span>
            <img
              :class="{'active bg--transp-01': isActive}"
              class="bor--radius-02"
              src="/img/trade/sell-tab.svg"
            >
          </span>
        </template>
      </exc-tabs> -->
    </trade-top-heading-block>
    <!-- <trade-history-book-header class="trade-last-orders__title pl-12 pr-12 txt--theme-08 txt--12px txt--height-41px bor--bottom bor--transp-01">
      <template>
        <exc-tabs
          :selected-button="typeTab"
          :buttons="tabs"
          no-active-item-styles
          tab-key="value"
          size="xs"
          class="trade-last-orders__tabs"
          @change-tab="onClickTab"
        >
          <template #all="{ isActive }">
            <span>
              <img
                :class="{'active bg--transp-01': isActive}"
                class="bor--radius-02"
                src="/img/trade/all-tab.svg"
              >
            </span>
          </template>
          <template #buy="{ isActive }">
            <span>
              <img
                :class="{'active bg--transp-01': isActive}"
                class="bor--radius-02"
                src="/img/trade/buy-tab.svg"
              >
            </span>
          </template>
          <template #sell="{ isActive }">
            <span>
              <img
                :class="{'active bg--transp-01': isActive}"
                class="bor--radius-02"
                src="/img/trade/sell-tab.svg"
              >
            </span>
          </template>
        </exc-tabs>
      </template>
    </trade-history-book-header> -->
    <trade-last-orders-container
      :type="typeTab.value"
      class="trade-last-orders__content"
    />
    <!-- <exc-table
      ref="table"
      :table-title="'Order book'"
      :heading="columns"
      :rows="rows"
      :loading="loading"
      :empty-message="$t('aacnew.notrades')"
      :tooltip-config="tooltipConfig"
      cell-size="s"
      class="trade-last-orders__table bg--theme-02"
      @select-row="handleRowClick"
      @on-mouse-over="setRowTitleInfo"
    >
      <template #widgets>
        <exc-base-tabs
          :selected-button="typeTab"
          :buttons="tabs"
          no-active-item-styles
          tab-key="value"
          size="xs"
          class="trade-last-orders__tabs"
          @change-tab="onClickTab"
        >
          <template #all="{ isActive }">
            <span>
              <img
                :class="{'active bg--transp-01': isActive}"
                class="bor--radius-02"
                src="/img/trade/all-tab.svg"
              >
            </span>
          </template>
          <template #buy="{ isActive }">
            <span>
              <img
                :class="{'active bg--transp-01': isActive}"
                class="bor--radius-02"
                src="/img/trade/buy-tab.svg"
              >
            </span>
          </template>
          <template #sell="{ isActive }">
            <span>
              <img
                :class="{'active bg--transp-01': isActive}"
                class="bor--radius-02"
                src="/img/trade/sell-tab.svg"
              >
            </span>
          </template>
        </exc-base-tabs>
      </template>
      <template #td-price="{ amount, price }">
        <span
          :class="{'trade-last-orders__change-trend': !amount.value && price.value}"
        >
          {{ price.value }}
          <trade-type-arrow
            v-if="!amount.value && price.value"
          />
        </span>
      </template>
    </exc-table> -->
  </div>
</template>

<script>
import { uiKitSizes } from '@/lib/utils'
import { mapGetters, mapState } from 'vuex'
import { mapFieldsToComputed } from '@/store/lib/vuex-form'
// import { getSumFromStack } from '@/lib/utils'
import {
  // lastOrdersTabs,
  lastOrdersCurrentTab,
  // changeCurrentTab,
} from './trade-last-orders-elements/tradeLastOrdersHelpers.js'

export default {
  name: 'TradeLastOrders',
  components: {
    TradeTopHeadingBlock: () =>
      import(
        /* webpackMode: "eager" */ '@/components/trade/TradeTopHeadingBlock.vue'
      ),
    TradeLastOrdersContainer: () =>
      import(
        /* webpackMode: "eager" */ '@/components/trade/trade-last-orders-elements/TradeLastOrdersContainer.vue'
      ),
    // TradeTypeArrow: () =>
    //   import(/* webpackMode: "eager" */ '@/icons/trade-type-arrow.svg'),
    // TradeHistoryBookHeader: () =>
    //   import(
    //     /* webpackMode: "eager" */ '@/components/trade/trade-common-elements/TradeHistoryBookHeader.vue'
    //   ),
    TradeLastOrdersTabs: () =>
      import(
        /* webpackMode: "eager" */ '@/components/trade/trade-last-orders-elements/TradeLastOrdersTabs.vue'
      ),
    // ExcButton,
    // ExcTabs,
  },
  props: {
    // tradeType: {
    //     type: String,
    //     required: true,
    //     validator: value => [
    //         "sell",
    //         "buy",
    //     ].includes(value),
    // },
    hideTitleBreakpoint: {
      type: String,
      validator: v => [...uiKitSizes, '', '1366px'].includes(v),
      default: '',
    },
  },
  data () {
    return {
      tableId: 'latestOrders',
      // tooltipConfig: {
      //     alignment: {
      //         target: {
      //             horizontal: AlignType.Middle,
      //             vertical: AlignType.Top,
      //         },
      //         overlay: {
      //             horizontal: AlignType.Middle,
      //             vertical: AlignType.Top,
      //         },
      //     },
      // },
    }
  },
  computed: {
    // tabs() {
    //     return ([
    //         {
    //             value: 'all',
    //             label: '+-',
    //         },
    //         {
    //             value: 'buy',
    //             label: '+',
    //         },
    //         {
    //             value: 'sell',
    //             label: '-',
    //         },
    //     ])
    // },
    ...mapGetters([
      // "getCurrentPair",
      'ordersByPair',
      // "getCurrencyAvailableBalance",
      // 'getCurrentPair',
      // "getCurrentPairName"
    ]),
    ...mapGetters({
      getCurrentPairName: 'pairs/getCurrentPairName',
      getCurrentPair: 'pairs/getCurrentPair',
    }),
    ...mapState({
      // pair: state => state.pairs.currentPair,
      loading: state =>
        state.pairs.fetchStatus === 'loading' ||
        state.pairs.fetchStatus === 'init',
      total (_, getters) {
        return getters[`trade/${this.tradeType}DepthTotal`]
      },
      depth (_, getters) {
        switch (this.typeTab) {
          case 'all':
            return [
              ...getters['trade/sellDepth'](this.pair)
                .slice(0, 5)
                .map(order => [...order, { type: 'sell' }]),
              this.avaragePrice,
              ...getters['trade/buyDepth'](this.pair)
                .map(order => [...order, { type: 'buy' }])
                .slice(0, 5),
            ]
          case 'buy':
            return [
              this.avaragePrice,
              ...getters['trade/buyDepth'](this.pair).map(order => [
                ...order,
                { type: 'buy' },
              ]),
            ]
          case 'sell':
            return [
              this.avaragePrice,
              ...getters['trade/sellDepth'](this.pair).map(order => [
                ...order,
                { type: 'sell' },
              ]),
            ]
        }
      },
      fee: state => state.buySell.fee,
    }),
    pair () {
      return this.getCurrentPairName
    },
    classes () {
      return {
        [`trade-last-orders--${this.hideTitleBreakpoint}`]: this
          .hideTitleBreakpoint,
      }
    },
    avaragePrice () {
      return +this.price || +this.volumeFiat
        ? [this.price, '', this.volumeFiat]
        : []
    },
    ...mapFieldsToComputed('exchange/exchangeMarketSellForm', {
      giveSell: 'give',
      // receiveSell: "receive",
      // giveCurrencySell: "giveCurrency",
      // receiveCurrencySell: "receiveCurrency"
    }),
    ...mapFieldsToComputed('exchange/exchangeMarketBuyForm', {
      // giveBuy: "give",
      receiveBuy: 'receive',
      // giveCurrencyBuy: "giveCurrency",
      // receiveCurrencyBuy: "receiveCurrency"
    }),
    changeClass () {
      return parseFloat(this.change) > 0
        ? 'txt--green trade-last-orders__up'
        : 'txt--red trade-last-orders__down'
    },
    myOrders () {
      return this.ordersByPair(this.pair).map(item => item.price)
    },
    change () {
      return this.getCurrentPair.market.change
    },
    price () {
      return this.getCurrentPair.market.price || ''
    },
    volumeFiat () {
      return this.getCurrentPair.market.volumeInMoney || ''
    },
    typeTab () {
      return lastOrdersCurrentTab.tab
    },
  },
  methods: {
    onClickTab ({ value }) {
      this.typeTab = value
    },
  },
}
</script>

<style lang="scss" scoped>
.trade-last-orders {
  $breakpoints: xs, s, m, l, xl;
  $laptop-screen: 1366px;
  $root: &;

  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  @each $bp in $breakpoints {
    &--#{$bp} {
      #{$root}__title {
        display: none;

        @include bp($bp) {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }

  &__head {
    display: none;
    align-items: center;
    justify-content: space-between;

    @include bp($laptop-screen) {
      display: flex;
      max-height: toRem(45px);
    }
  }

  &__title {
    @include bp(0, l) {
      display: none;
    }
  }

  &__table {
    max-height: toRem(405px);

    @include bp(l) {
      max-height: 100%;
    }
  }

  &__title {
    display: none;

    @include bp($laptop-screen) {
      display: flex;
      // height: toRem(41px);
      justify-content: space-between;
    }
  }

  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    @include bp(l) {
      height: 93%;
    }
  }

  &::v-deep {
    #{$root}__hide {
      display: none;
    }

    #{$root}__up svg {
      transform: rotate(180deg);
    }

    #{$root}__change-trend {
      display: flex;
      align-items: center;
    }
  }
}
</style>
